<div class="overflow-x-auto">
	<app-teranet-pin-view class="block"></app-teranet-pin-view>

	<div class="overflow-y-auto p-10">
		<app-teranet-instruments></app-teranet-instruments>
	</div>
</div>

<ui-content-footer
	[primaryAction]="{ text: 'Continue', action: next }"
	[secondaryAction]="{ text: 'Back', action: back }"
	[testHook]="testHooks.ContentFooter"
></ui-content-footer>
